export const FETCH_SCHEMAS = 'FETCH_SCHEMAS';
export const FETCH_SCHEMAS_SUCCESS = 'FETCH_SCHEMAS_SUCCESS';
export const FETCH_SCHEMAS_ERROR = 'FETCH_SCHEMAS_ERROR';
export const fetchSchemas = () => ({ type: FETCH_SCHEMAS });
